import React, { useEffect, useState, useCallback, useMemo } from "react";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import Input from "../../../../components/Common/Input/Input";
import { isNameExistsActionHandler } from "../../../../store/actions/actionHandlers/manageActionHandler";
import Button from "../../../../components/Common/Button/Button";
import { createNewEvent } from "../../../../utils/mainTabs/events/createNewEvent";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import { detailsSchema } from "../../../../utils/mainTabs/events/eventSchema";
import classes from "./EventDetails.module.scss";
import {
  createEventShotclassActionHandler,
  updateEventShotclassActionHandler,
  copyEventShotclassActionHandler,
} from "../../../../store/actions/actionHandlers/eventActionHandler";
import { events } from "../../../../utils/mainTabs/events/events";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import AddTrainingTypeModal from "../../../../components/Manage/AddTrainingTypeModal/AddTrainingTypeModal";
import PlusIcon from "../../../../components/Common/SvgIcons/CommonIcons/PlusIcon";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { roleMenuList } from "../../../../utils/roleMenuList";
import RoleMenuChek from "../../../../hoc/RoleMenuCheck";
import { featureList } from "../../../../utils/featureList";
// import { usePrompt } from "../../../../hooks/preventNavigationHook";

const EventDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { tenantName } = useOutletContext();
  // const [allLanguageVariant, setAllLanguageVariant] = useState([]);

  const [exitNameExist, setExitNameExist] = useState(null);
  const [formData, setFormData] = useState([]);
  const [validClassName, setValidClassName] = useState(true);
  // const [languageDefaultValue, setLanguageDefaultValue] = useState([]);
  const [searchTrainingTypeList, setSearchTrainingTypeList] = useState([]);
  const [isAddTrainingTypeModal, setIsAddTrainingTypeModal] = useState(false);
  const [saveDraftLoader, setSaveDraftLoader] = useState(false);
  const [normalExit, setNormalExit] = useState(false);

  const disabeldFieldsEditPath = location.pathname.includes(
    createNewEvent.editpath(tenantName)
  );
  const disabeldFieldsCopyPath = location.pathname.includes(
    createNewEvent.copypath(tenantName)
  );
  const disabeldFieldsViewPath = location.pathname.includes(
    createNewEvent.viewpath(tenantName)
  );
  const manageState = useSelector((state) => state.manageReducer);
  const { getClassDetailsById } = manageState;

  const {
    formValues,
    setFormValues,
    eventTiles,
    setEventTiles,
    allLanguageVariant,
    trainingTypes,
    setTrainingTypes,
    shotclassType,
    shotclassTypeFrom,
    eventPath,
    createNewEventPath,
    roleTitle,
    setRoleTitle,
    isTenantProfileNameExist,
  } = useOutletContext();
  const handleNameExists = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value.trim();
      if (val) {
        const encodedVal = encodeURIComponent(val);
        if (/^[a-zA-Z0-9:_@?#|'`\]\[ ]*$/.test(val)) {
          setValidClassName(true);
          dispatch(isNameExistsActionHandler(encodedVal, setExitNameExist));
        } else {
          setValidClassName(false);
        }
      } else {
        setValidClassName(true);
        setExitNameExist(false);
      }
    },
    [dispatch, setExitNameExist, setValidClassName]
  );
  const handleAddTrainingType = useCallback(() => {
    setIsAddTrainingTypeModal(!isAddTrainingTypeModal);
  }, [isAddTrainingTypeModal]);
  useEffect(() => {
    if (shotclassType === "copy") {
      dispatch(
        isNameExistsActionHandler(
          getClassDetailsById?.Name + "_Copy",
          setExitNameExist
        )
      );
    }
  }, [dispatch, shotclassType, getClassDetailsById?.Name]);
  useEffect(() => {
    if (trainingTypes?.length > 0) {
      const updatedTrainingTypes = trainingTypes?.map((trainingType) => {
        return { ...trainingType, isVisible: true };
      });
      setSearchTrainingTypeList(updatedTrainingTypes);
    }
  }, [trainingTypes]);

  const handleSearchTrainingType = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value;
      if (val) {
        const filteredTrainingTypes = trainingTypes?.filter((trainingType) =>
          trainingType.Name?.toLowerCase().includes(val?.toLowerCase())
        );
        setSearchTrainingTypeList(filteredTrainingTypes);
      } else {
        setSearchTrainingTypeList(trainingTypes);
      }
    },
    [trainingTypes]
  );

  useEffect(() => {
    if (trainingTypes?.length > 0) {
      eventTiles?.forEach((tile) => {
        if (location.pathname === tile.path) {
          let data = tile.formData(
            allLanguageVariant,
            trainingTypes,
            shotclassType,
            handleNameExists
          );
          setFormData(data);
        }
      });
    }
  }, [
    location,
    shotclassType,
    eventTiles,
    allLanguageVariant,
    handleNameExists,
    trainingTypes,
    setSearchTrainingTypeList,
    handleAddTrainingType,
    searchTrainingTypeList,
  ]);

  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(detailsSchema),
    defaultValues: useMemo(() => {
      return {
        ...formValues.details,
      };
    }, [formValues.details]),
  });
  useEffect(() => {
    setValue("Language", allLanguageVariant[0]?.Locale);
  }, [allLanguageVariant]);

  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    setValue,
    watch,
    reset,
    getValues,
  } = methods;

  useEffect(() => {
    reset(formValues.details);
  }, [formValues.details, reset]);

  const onSubmit = (data) => {
    let updatedTiles = eventTiles.map((tile) => {
      if (tile.path === `${createNewEventPath}/details`) {
        return { ...tile, isCompleted: true };
      } else {
        return tile;
      }
    });
    // const selectedTrainingTypes = data?.TrainingType?.map(
    //   (training) => training.TypeId
    // );
    setFormValues((formValues) => {
      return {
        ...formValues,
        details: {
          ...formValues.details,
          ...data,
          // TrainingType: selectedTrainingTypes,
        },
        disableTabsOnValid:
          formValues?.addQuiz?.TotalQuestionCount == 0 ? false : true,
      };
    });
    setEventTiles(() => updatedTiles);
    navigate(`${createNewEventPath}/addQuiz`);
  };
  const clearAll = () => {
    reset();
    setValidClassName(true);
    setExitNameExist(false);
  };

  const saveDetailDraft = () => {
    //setNormalExit(false);
    setSaveDraftLoader(true);
    const detailsData = getValues();
    // let shotclassDetailData = { ...formValues, details: getValues() };
    // const selectedTrainingTypes = detailsData?.TrainingType?.map(
    //   (training) => training.TypeId
    // );
    let shotclassDetailData = {
      ...formValues,
      details: { ...detailsData },
      // TrainingType: selectedTrainingTypes
    };
    if (shotclassType === "edit") {
      dispatch(
        updateEventShotclassActionHandler(shotclassDetailData, "Saved")
      ).then(() => navigate(eventPath));
      dispatch(
        setErrorHandler(
          errorTypes.SUCCESS,
          "Event has been saved successfully, You Can view same in My Draft"
        )
      );
      // navigate(events.path);
      setSaveDraftLoader(false);
    } else if (shotclassType === "copy") {
      dispatch(
        copyEventShotclassActionHandler(shotclassDetailData, "Saved")
      ).then(() => navigate(eventPath));
      dispatch(
        setErrorHandler(
          errorTypes.SUCCESS,
          "Event has been saved successfully, You Can view same in My Draft"
        )
      );
      setSaveDraftLoader(false);
    } else {
      dispatch(
        createEventShotclassActionHandler(shotclassDetailData, "Saved")
      ).then(() => navigate(eventPath));
      dispatch(
        setErrorHandler(
          errorTypes.SUCCESS,
          "Event has been saved successfully, You Can view same in My Draft"
        )
      );
      setSaveDraftLoader(false);
    }
  };
  // useEffect(() => {
  //   if (isDirty) setNormalExit(true);
  // }, [setNormalExit, isDirty]);

  // usePrompt("Are you sure you want to leave this page?", normalExit);
  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={classes.eventDetailsMain}>
            <div className={classes.eventDetails}>
              <Input
                label="Course Language"
                name="Language"
                labelColor="dark"
                required
                type="select"
                fieldName="Value"
                fieldValue="Locale"
                valueArr={allLanguageVariant}
                defaultValue={allLanguageVariant[0]?.Value}
                width="33.33"
                height="5"
                borderRadius="0.8"
                disabled
                // style={{
                //   cursor: "no-drop",
                //   backgroundColor: "rgb(227 227 227 / 42%)",
                //   width: "33.33rem",
                //   height: "5rem",
                //   borderRadius: "0.8rem",
                // }}
              />
              <div>
                <Input
                  label={<FormattedMessage id="CLASSNAME_TEXT" />}
                  name="Name"
                  labelColor="dark"
                  required
                  placeholder="Enter Event Name"
                  // error={errors.name?.message}
                  width="33.33"
                  onChange={handleNameExists}
                  disabled={disabeldFieldsEditPath || disabeldFieldsViewPath}
                  maxLength={70}
                  // style={{
                  //   cursor: disabeldFieldsEditPath &&  "no-drop",
                  //   backgroundColor: disabeldFieldsEditPath &&  "rgb(227 227 227 / 42%)",
                  //   width: "33.33rem",
                  //   height: "5rem",
                  //   borderRadius: "0.8rem",
                  // }}
                />
                {errors?.Name?.message ? (
                  <div className={classes.eventDetails__nameAlreadyExist}>
                    {errors.Name?.message}
                  </div>
                ) : exitNameExist ? (
                  <div className={classes.eventDetails__nameAlreadyExist}>
                    Sorry, Name already exists
                  </div>
                ) : !validClassName ? (
                  <div className={classes.eventDetails__nameAlreadyExist}>
                    Only alphanumeric and special characters like ':#@?[]_`| are
                    allowed
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <Input
                label={<FormattedMessage id="TRAINING_TYPE" />}
                labelColor="dark"
                name="TrainingType"
                fieldName="Name"
                fieldValue="TypeId"
                required
                type="noSearchTags"
                tagType="single"
                buttonLabel="Select Training Type"
                placeholder="Search Training Type"
                error={errors.TrainingType?.message}
                // valueArr={trainingTypes}
                searchTagsList={searchTrainingTypeList}
                handleTagList={(tagsList) => {
                  setSearchTrainingTypeList(tagsList);
                }}
                // width="33.33"
                // disabled={disabeldFieldsViewPath}

                height="4"
                searchable={true}
                subButtonLabel="Add New"
                subButtonIcon={PlusIcon}
                handleSubButton={handleAddTrainingType}
                // width: "27",
                disabled={false}
                isTagCheckBoxVisible={false}
                addedTagsVisible={false}
              />
            </div>
            <div className={classes.eventDetailsRadioBtns}>
              <div className={classes.eventDetailsRadioBtns__label}>
                <FormattedMessage id="TAG_TEXT" />{" "}
                <span style={{ color: "red" }}>*</span>
              </div>
              <div className={classes.eventDetailsRadioBtns__RadioButtons}>
                <RoleMenuChek
                  // type={[roleMenuList?.EVENTS?.VIRTUAL_QUIZ]}
                  feature={[
                    {
                      roleMenu: roleMenuList?.EVENTS.VIRTUAL_QUIZ,
                      MSOMMenu: featureList?.VIRTUAL_QUIZ,
                    },
                  ]}
                >
                  <Input
                    label={"Virtual Quiz"}
                    name="Tags"
                    type="radio"
                    labelColor="light"
                    direction={"row-reverse"}
                    width="2"
                    height="2"
                    value="virtualtraining"
                    disabled={
                      disabeldFieldsEditPath ||
                      disabeldFieldsCopyPath ||
                      disabeldFieldsViewPath
                    }
                    disableLabelClick
                  />
                </RoleMenuChek>
                <RoleMenuChek
                  // type={[roleMenuList?.EVENTS?.LIVE_QUIZ]}
                  feature={[
                    {
                      roleMenu: roleMenuList?.EVENTS?.LIVE_QUIZ,
                      MSOMMenu: featureList?.LIVE_QUIZ,
                    },
                  ]}
                >
                  <Input
                    label={"Live Quiz"}
                    name="Tags"
                    type="radio"
                    labelColor="light"
                    direction={"row-reverse"}
                    width="2"
                    height="2"
                    value="livetraining"
                    disabled={
                      disabeldFieldsEditPath ||
                      disabeldFieldsCopyPath ||
                      disabeldFieldsViewPath
                    }
                    disableLabelClick
                  />
                </RoleMenuChek>

                {/* {roleTitle.includes("VIRTUAL_QUIZ_TEXT") ? (
                  isTenantProfileNameExist.includes("VirtualQuizzing") && (
                    <Input
                      label={"Virtual Quiz"}
                      name="Tags"
                      type="radio"
                      labelColor="light"
                      direction={"row-reverse"}
                      width="2"
                      height="2"
                      value="virtualtraining"
                      disabled={
                        disabeldFieldsEditPath ||
                        disabeldFieldsCopyPath ||
                        disabeldFieldsViewPath
                      }
                    />
                  )
                ) : (
                  <></>
                )}

                {roleTitle.includes("LIVE_QUIZ_TEXT") ? (
                  isTenantProfileNameExist.includes("LiveQuizzing") && (
                    <Input
                      label={"Live Quiz"}
                      name="Tags"
                      type="radio"
                      labelColor="light"
                      direction={"row-reverse"}
                      width="2"
                      height="2"
                      value="livetraining"
                      disabled={
                        disabeldFieldsEditPath ||
                        disabeldFieldsCopyPath ||
                        disabeldFieldsViewPath
                      }
                    />
                  )
                ) : (
                  <></>
                )} */}
              </div>
            </div>
            <div className={classes.eventDetailsButtons}>
              {isDirty && (
                <>
                  <div
                    className={classes.eventDetailsButtons_ClearAll}
                    onClick={clearAll}
                  >
                    <FormattedMessage id="CLEAR_ALL_TXT" />
                  </div>
                </>
              )}
              {(shotclassType !== "edit" ||
                (shotclassType === "edit" &&
                  shotclassTypeFrom === "myDrafts")) && (
                <Button
                  label={<FormattedMessage id="SAVE_CLASS_TEXT" />}
                  disabled={
                    !isValid ||
                    disabeldFieldsViewPath ||
                    !validClassName ||
                    exitNameExist
                  }
                  small
                  dark
                  onClick={() => {
                    saveDetailDraft();
                    //setNormalExit(false);
                  }}
                  loading={saveDraftLoader}
                />
              )}
              <Button
                label={"Add Quiz"}
                small
                dark
                type={"submit"}
                disabled={!isValid || !validClassName || exitNameExist}
                //onClick={() => setNormalExit(false)}
              />
            </div>
          </div>
        </form>
      </FormProvider>
      <AddTrainingTypeModal
        handleAddTrainingTypeModal={handleAddTrainingType}
        isAddTrainingTypeModal={isAddTrainingTypeModal}
        setTrainingTypes={setTrainingTypes}
        setValue={setValue}
      />
    </>
  );
};

export default EventDetails;
